import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'axios';
import { Calendar, Users, MapPin, Plus } from 'lucide-react';

const Dashboard = () => {
  const { data: festivalsData, isLoading } = useQuery('festivals', async () => {
    const response = await axios.get('/api/festivals');
    return response.data;
  });

  const festivals = festivalsData?.festivals || [];
  const activeFestivals = festivals.filter(f => f.status === 'published');
  const draftFestivals = festivals.filter(f => f.status === 'draft');

  if (isLoading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h2>Dashboard</h2>
        <Link to="/admin/festivals" className="btn btn-primary">
          <Plus size={16} style={{ marginRight: '8px' }} />
          Create Festival
        </Link>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        <div style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
            <Calendar size={24} color="#007bff" />
            <h3>Total Festivals</h3>
          </div>
          <p style={{ fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{festivals.length}</p>
        </div>

        <div style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
            <MapPin size={24} color="#28a745" />
            <h3>Published</h3>
          </div>
          <p style={{ fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{activeFestivals.length}</p>
        </div>

        <div style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
            <Users size={24} color="#ffc107" />
            <h3>Drafts</h3>
          </div>
          <p style={{ fontSize: '32px', fontWeight: 'bold', color: '#333' }}>{draftFestivals.length}</p>
        </div>
      </div>

      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: '20px' }}>Recent Festivals</h3>
        {festivals.length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center', padding: '40px' }}>
            No festivals created yet. <Link to="/admin/festivals">Create your first festival</Link>
          </p>
        ) : (
          <div style={{ display: 'grid', gap: '15px' }}>
            {festivals.slice(0, 5).map(festival => (
              <div key={festival.id} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '15px',
                border: '1px solid #e0e0e0',
                borderRadius: '6px'
              }}>
                <div>
                  <h4>{festival.name}</h4>
                  <p style={{ color: '#666', fontSize: '14px' }}>
                    {new Date(festival.start_date).toLocaleDateString()} - {new Date(festival.end_date).toLocaleDateString()}
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    background: festival.status === 'published' ? '#d4edda' : '#fff3cd',
                    color: festival.status === 'published' ? '#155724' : '#856404'
                  }}>
                    {festival.status}
                  </span>
                  <Link
                    to={`/admin/festivals/${festival.id}/edit`}
                    className="btn btn-secondary"
                    style={{ fontSize: '12px', padding: '6px 12px' }}
                  >
                    Edit
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
